import * as Config from '../../config';
import { default as Locale } from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from '../Types';
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types"


export class PumpDryRunProtection extends AlertLogic {
    static type = AlertType.PumpDryRunProtection;
    static category = AlertCategories.EQUIPMENT_FAILURE;
    static contentCategories = [ ContentCategories.WATER_FLOW ];
    static title = Locale.gettext('Dry Run Protection Activated');

    getInfo(alert:AlertRecord = this.alert, config:Config.AllConfig = this.allConfigs):AlertInfo {
        let { body, device, alertData, firstReported } = this.getCommons(alert, config);

        const alertInto = AlertInfo.fromCardConfig({
            cardTitle: PumpDryRunProtection.title,
            cardIllustration: 'report_frightened',
            cardDescription: Locale.gettext("Heating, cooling, and chemistry devices have been disabled!"),
            detailIcon: 'pump',
            detailDescriptionArr: [
                Locale.gettext("Your system is configured to prevent your pumps from running when they are unable move water. Operating pumps that have lost prime can result in bearing or impeller damage and should be avoided."),
                Locale.gettext("Please check your pumps and ensure they are able to prime successfully. When you are ready to try again please turn off your currently enabled control and then turn it back on to restart your pumps."),
                Locale.gettext("This alert was generated because a flow switch (%s) did not successfully register flow.",
                    alertData?.FlowSwitches?.map(item  => (item.Name || item.UUID)).join(", ")
                )
            ],
        });
        alertInto.contentCategories = PumpDryRunProtection.contentCategories;
        return alertInto;
    } 

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord|AlertRecord[] {
        const device = config.Config.Devices.find(dev => dev.DeviceType === Config.DeviceTypes.PUMP);
        const FlowSwitches = config.Config.Devices
            .filter(dev => dev.DeviceType === Config.DeviceTypes.FLOWSWITCH)
            .map(dev => ({
                UUID: dev.UUID,
                Name: dev.Name,

                /* Example FlowSwithch array item props that could come from the controller
                "HardwareFlowMeter": {
                    "UUID": "2ae40700-a10e-4bdc-b25e-93a039dd4e5c"
                },
                "PersistentDeviceStates": {},
                "Hardware": {
                    "UUID": "2ae40700-a10e-4bdc-b25e-93a039dd4e5c"
                },
                "ActualPowerState": 0,
                "FlowRateGPM": null,
                "DesiredPowerState": 0,
                "IsOnline": true,
                "LastFlowStateChangeDateTime": "2025-11-10T09:29:45.283427-06:00",
                "MessagesSentWithoutResponse": 0,
                "LastMessageReceivedDateTime": "2025-11-10T10:45:47.051389-06:00",
                "State": 1,
                "UUID": "2ae40700-a10e-4bdc-b25e-93a039dd4e5c",
                "Name": "Flow Meter",
                "DeviceCount": 1,
                "BoosterPumps": [],
                "HeadLoss": 0,
                "ReturnsTo": null,
                "Winterized": false,
                "InformationFields": [
                    {
                        "Name": "FlowRateGPM",
                        "DisplayName": "Flow Rate",
                        "DisplayNameShort": "Flow Rate",
                        "DisplayOrder": 1,
                        "DisplayProcessingLogic": "GPM",
                        "DisplayProcessingLogicUnitAsDisplayName": false,
                        "DisplayWidth": "NORMAL",
                        "DisplayDiffTimeout": null,
                        "DisplayDiffThreshold": null,
                        "DisplayWhenOff": false,
                        "FieldTypes": [
                            "MAIN_METRIC"
                        ]
                    },
                    {
                        "Name": "State",
                        "DisplayName": "Flow Switch State",
                        "DisplayNameShort": "Flow",
                        "DisplayOrder": 2,
                        "DisplayProcessingLogic": "ONOFF",
                        "DisplayProcessingLogicUnitAsDisplayName": false,
                        "DisplayWidth": "FULL",
                        "DisplayDiffTimeout": null,
                        "DisplayDiffThreshold": null,
                        "DisplayWhenOff": false,
                        "FieldTypes": [
                            "INFORMATION"
                        ]
                    }
                ],
                "Passive": true
                */

                /* Example of FlowSwithch array item props that could come from the controller
                "PersistentDeviceStates": {},
                "Hardware": {
                    "UUID": "15dbeae7-d186-410b-b515-58FLOWSWITCH"
                },
                "State": 0,
                "IsOnline": true,
                "MessagesSentWithoutResponse": 0,
                "LastMessageReceivedDateTime": null,
                "LastFlowStateChangeDateTime": "2025-11-10T09:29:38.2708386-06:00",
                "UUID": "15dbeae7-d186-410b-b515-58FLOWSWITCH",
                "Name": "Flow Switch",
                "DeviceCount": 1,
                "BoosterPumps": [],
                "HeadLoss": 0,
                "ReturnsTo": null,
                "Winterized": false,
                "InformationFields": null,
                "Passive": true
                */

            }))
        ;
        
        return [
            new AlertRecord({
                id: Math.floor(Math.random() * 100000),
                uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
                siteId: Math.floor(Math.random() * 100000),
                deviceId: undefined,
                entityUuid: device.UUID,
                bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
                type,
                level: "FATAL",
                data: {
                    FlowSwitches,
                },
                /*
                state: "CLOSED",
                closedBy: null,
                created: new Date(),
                updated: new Date(),
                site: {},
                device: {},
                */
            }),
        ];
    }
}
